import React from "react";
import bannerImage from "../assets/images/home/banner.jpg";
import springValleyLogo from "../assets/images/home/springvalleylogo.jpg";

const HomePage = () => {
  return (
    <div className="page-content page-content-narrow">
      <h1>Home</h1>

        <div className="weather-container">
        <div className="weather-group">
          <div className="weather-header">
            <h2>About the Project</h2>
            <h3>Capstone Team 23</h3>
          </div>
          <div className="weather-body results-copy">
            <p>
              This project was built as a practical step toward precision agriculture at Spring
              Valley Student Farm. We deployed a weather station to collect on-site measurements
              such as air temperature, humidity, rainfall, solar radiation, wind direction, and
              wind speed, then organized that data into a dashboard that makes farm conditions
              easier to monitor and analyze.
            </p>

            <p>
              A central goal of the project was to test whether a small set of weather features
              could be used to estimate soil temperature, a metric that matters for planting and
              field decisions but is not always directly available. Because the farm sits in a
              valley and can experience different conditions than the surrounding area, collecting
              site-specific data is more useful than relying only on general regional weather.
              Together, the station data, historical analysis, and modeling results create a strong
              foundation for future precision-agriculture work at the farm.
            </p>
          </div>
        </div>

      <img
        src={springValleyLogo}
        alt="Spring Valley Student Farm mission"
        className="home-image home-hero-image"
      />

      <div className="weather-container">
        <div className="weather-group">
          <div className="weather-header">
            <h2>About the Farm</h2>
            <h3>Spring Valley Student Farm</h3>
          </div>
          <div className="weather-body results-copy">
            <p>
              The Spring Valley Student Farm (SVSF) is a vegetable farm owned by The University of
              Connecticut and run by 11 residential student farmers, managed by Jessica
              Larkin-Wells. The farm was founded in the Spring of 2010 and since then has provided
              the University of Connecticut&apos;s dining halls with fresh produce. Significant
              developments have arisen in the world of agricultural technology, including precision
              agriculture. Precision agriculture is defined as the application of information,
              technology, and management to optimize crop production. The farm currently does not
              utilize precision agriculture so applications of this practice promise vast
              improvements for crop yield.
            </p>
          </div>
        </div>
      </div>

      <img
        src={bannerImage}
        alt="Spring Valley Student Farm logo"
        className="home-image home-logo-image"
      />
      </div>
    </div>
  );
};

export default HomePage;
